import styled from 'styled-components';

export const StyledMetaversePopup = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: ${({ theme, $solid }) => $solid ? theme.backgroundDark : 'linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%)'};

  .metaverse-screen {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .metaverse-collapse {
    cursor: pointer;
    position: absolute;
    left: -2.5rem;
    top: 2rem;
    background: ${({ theme }) => theme.baseYellow};
    width: 2.5rem;
    height: 4.5rem;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-left: ${({ theme }) => theme.selection};
    img {
      width: 1.5rem;
      transition: transform .2s linear;
    }
    border: solid 1px rgba(0, 0, 0, .16);
    transition: 0.2s linear;
    &:hover {
      background: ${({ theme }) => theme.brightYellow};
      border: solid 1px ${({ theme }) => theme.borderYellow};
      img {
        transform: translateX(0.25rem);
      }
    }
  }

  .metaverse-content {
    width: 100%;
    overflow-y: auto;
  }
  .metaverse-sections {
    height: calc(100% - 125px);
  }

  .metaverse-sections-placeholder {
    height: 48px;
    width: 100%;
  }

  .metaverse-lighthouse {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 48px;
    width: 100%;
    background: ${({ theme }) => theme.background};
    display: flex;
    justify-content: end;
    flex-direction: row;
    align-items: center;
    padding: 20px 10px;
    text-transform: uppercase;
    div {
      font-family: "BebasNeue";
      font-size: 1.25em;
      color: white;
      padding-top: 4px;
      opacity: 0.4;
    }
  }

  .metaverse-decorator {
    border-top: solid 2px ${({ theme }) => theme.borderDark};
    border-bottom: solid 2px ${({ theme }) => theme.borderDark};
    background: ${({ theme }) => theme.selection};
    height: 90px;
    width: ${({ theme }) => theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    position: absolute;
    top: 32px;
    right: 0;
  }
`;

